module.exports = __webpack_public_path__ + "static/media/logo.2932d0ee.jpg";